export type TagColor = {
  name: string;
  value: string;
};

// タグ (プロジェクト) のカラーパレット。24 色 = 6×4 のグリッド。
// 先頭はニュートラル (既定色含む)、以降はカラーホイール順。
export const TAG_COLOR_PALETTE: readonly TagColor[] = [
  { name: 'ライトグレー', value: '#9ca3af' },
  { name: 'スレート', value: '#475569' },
  { name: 'グレー', value: '#4b5563' },
  { name: 'ストーン', value: '#57534e' },
  { name: 'ブラウン', value: '#78350f' },
  { name: 'レッド', value: '#dc2626' },
  { name: 'ローズ', value: '#e11d48' },
  { name: 'ピンク', value: '#db2777' },
  { name: 'フクシア', value: '#c026d3' },
  { name: 'パープル', value: '#9333ea' },
  { name: 'バイオレット', value: '#7c3aed' },
  { name: 'インディゴ', value: '#4f46e5' },
  { name: 'ネイビー', value: '#1e3a8a' },
  { name: 'ブルー', value: '#2563eb' },
  { name: 'スカイ', value: '#0284c7' },
  { name: 'シアン', value: '#0891b2' },
  { name: 'ティール', value: '#0d9488' },
  { name: 'エメラルド', value: '#059669' },
  { name: 'グリーン', value: '#16a34a' },
  { name: 'ライム', value: '#65a30d' },
  { name: 'オリーブ', value: '#4d7c0f' },
  { name: 'イエロー', value: '#ca8a04' },
  { name: 'アンバー', value: '#d97706' },
  { name: 'オレンジ', value: '#ea580c' },
];

export const DEFAULT_TAG_COLOR = TAG_COLOR_PALETTE[0].value;
